import React, { Component } from "react";
import IntegratorCompaniesTable from "./Table";
import CircularProgress from "material-ui/CircularProgress";
import styles from "styles";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getIntegratorCompanies } from "actions/integrators/integrators";
import { checkParams } from "../utils";

export class IntegratorCompaniesPage extends Component {
  UNSAFE_componentWillMount() {
    const {
      params: { id = "" } = {},
      getIntegratorCompanies,
      page,
      limit,
    } = this.props;
    checkParams(id);
    getIntegratorCompanies({
      id,
      page,
      limit,
    });
  }
  render() {
    const { isLoaded } = this.props;
    return (
      <div id="companies-list" className="table-page">
        <CircularProgress
          className={!isLoaded ? "" : "hidden"}
          style={styles.circularProgress}
        />

        <div className={isLoaded ? "" : "hidden"}>
          <div className="container-fluid">
            <h2>Integrator's companies</h2>
            <IntegratorCompaniesTable />
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  ({ integratorCompanies }) => ({
    isLoaded: integratorCompanies.isLoaded,
    page: integratorCompanies.page,
    limit: integratorCompanies.limit,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        getIntegratorCompanies,
      },
      dispatch
    )
)(IntegratorCompaniesPage);



// WEBPACK FOOTER //
// ./app/components/Integrators/Companies/Page.jsx